import { useEffect, useRef, useState } from "react";

import { API } from "@/App";

export const DenoiseCompare = ({ id = "denoise", before = "denoise-street-noisy", after = "denoise-street-clean", color = "#00e5ff", beforeLabel = "noisy source · ISO 8000", afterLabel = "KolorKlinic Denoise", aspect = "aspect-video", start = 50, v = "" }) => {
  const box = useRef(null);
  const noisy = useRef(null);
  const clean = useRef(null);
  const dragging = useRef(false);
  const [pos, setPos] = useState(start);

  const move = (clientX) => {
    const r = box.current.getBoundingClientRect();
    setPos(Math.min(100, Math.max(0, ((clientX - r.left) / r.width) * 100)));
  };

  useEffect(() => {
    const id = setInterval(() => {
      const a = noisy.current, b = clean.current;
      if (a && b && Math.abs(a.currentTime - b.currentTime) > 0.08) b.currentTime = a.currentTime;
    }, 500);
    return () => clearInterval(id);
  }, []);

  const onDown = (e) => { dragging.current = true; e.currentTarget.setPointerCapture(e.pointerId); move(e.clientX); };
  const onMove = (e) => { if (dragging.current) move(e.clientX); };
  const onUp = () => { dragging.current = false; };
  const onKey = (e) => {
    if (e.key === "ArrowLeft") setPos((p) => Math.max(0, p - 2));
    if (e.key === "ArrowRight") setPos((p) => Math.min(100, p + 2));
  };

  return (
    <figure
      ref={box}
      onPointerDown={onDown} onPointerMove={onMove} onPointerUp={onUp} onPointerCancel={onUp}
      className={`relative bg-black border border-[#2a2f3d] overflow-hidden select-none cursor-ew-resize touch-none ${aspect}`}
      data-testid={`${id}-demo`}
    >
      <video ref={noisy} src={`${API}/media/${before}.mp4${v ? `?v=${v}` : ""}`} muted loop autoPlay playsInline className="absolute inset-0 w-full h-full object-cover pointer-events-none" data-testid={`${id}-before-video`} />
      <video ref={clean} src={`${API}/media/${after}.mp4${v ? `?v=${v}` : ""}`} muted loop autoPlay playsInline style={{ clipPath: `inset(0 0 0 ${pos}%)` }} className="absolute inset-0 w-full h-full object-cover pointer-events-none" data-testid={`${id}-after-video`} />
      <div className="absolute inset-y-0 w-px pointer-events-none" style={{ left: `${pos}%`, background: color }} data-testid={`${id}-divider`}>
        <div
          role="slider" tabIndex={0} aria-label="Compare before and after" aria-valuenow={Math.round(pos)} aria-valuemin={0} aria-valuemax={100}
          onKeyDown={onKey}
          className="pointer-events-auto absolute top-1/2 -translate-x-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-black/80 border grid place-items-center text-xs font-mono transition-transform hover:scale-110 focus:outline-none focus:ring-2"
          style={{ borderColor: color, color }}
          data-testid={`${id}-divider-handle`}
        >
          ◂▸
        </div>
      </div>
      <span className="absolute top-3 left-3 chip bg-black/70 pointer-events-none">{beforeLabel}</span>
      <span className="absolute top-3 right-3 chip bg-black/70 pointer-events-none" style={{ color, borderColor: color }}>{afterLabel}</span>
    </figure>
  );
};
